import Lockr from 'lockr';
import _ from 'lodash';

export default {
  userinfo (state) {
    return () => {
      if (Lockr.get('userinfo')) {
        return Lockr.get('userinfo');
      } else {
        return state.userinfo;
      }
    };
  },
  // apiKey (state) {
  //   return this.userinfo().api_key;
  // },
  listQuery (state) {
    return state.filterWrapper.listQuery;
  },
  modelList (state) {
    return state.modelList;
  },
  fullscreenLoading (state) {
    return state.fullscreenLoading;
  },
  markImageList (state) {
    return () => {
      // if (Lockr.get('markImageList')) {
      //   return Lockr.get('markImageList');
      // } else {
      return state.markImageList;
      // }
    };
  },
  currentDishModelIndex (state) {
    return state.currentDishModelIndex;
  },
  batchList (state) {
    // console.log(state.batchList);
    return state.batchList;
  },
  canteenList (state) {
    return state.global.canteenList;
  },
  machineList (state) {
    return state.global.machineList;
  },
  allClassList (state) {
    return state.allClassList;
  },
  batchTag (state) {
    return state.batchTag;
  },
  uncheckedDishList (state) {
    return state.uncheckedDishList;
  },
  subtitle (state) {
    return state.subtitle;
  },
  markedImageList (state) {
    return state.markedImageList;
  },
  checkTextObjList (state) {
    return state.checkTextObjList;
  },
  subMenuShow (state) {
    return state.subMenuShow;
  },
  allCanteenList (state) {
    return state.allCanteenList;
  },
  taskFormData (state) {
    return state.taskFormData;
  },
  detectedUnCheckList (state) {
    return state.detectedUnCheckList;
  },
  backDataUnCheckList (state) {
    return state.backDataUnCheckList;
  },
  dataCollectCheckRemindList (state) {
    return state.dataCollectCheckRemindList;
  },
  taskList (state) {
    return [
      ...state.detectedUnCheckList,
      ...state.backDataUnCheckList,
      ...state.dataCollectCheckRemindList
    ];
  },
  allImageList (state) {
    return state.allImageList;
  },
  taskUuid (state) {
    return state.taskUuid;
  },
  currentCheckTaskInfo (state) {
    return state.currentCheckTaskInfo;
  },
  downloadImageList (state) {
    return state.downLoadImageList;
  },
  cachedDishList (state) {
    return state.cachedDishList;
  },
  checkingTaskUUID (state) {
    return state.checkingTaskUUID;
  },
  taskUUIDForTrainList (state) {
    return _.flatten(state.taskUUIDForTrain);
  },
  checkRegionData (state) {
    return state.checkRegionData;
  },
  premarkData (state) {
    return state.premarkData;
  },
  active_label_task_id (state) {
    return state.label_task_id;
  },
  standardRegionModel (state) {
    return state.standardRegionModel;
  },
  allMachineList (state) {
    return state.allMachineList;
  },
  customMachineList (state) {
    return state.customMachineList;
  },
  api_version_list (state) {
    return _.uniqBy(state.api_version_list, 'value');
  },
  sideBarFold (state) {
    console.log(state.sideBarFold);
   return state.sideBarFold;
  },
  category_list (state) {
    return state.category_list;
  }
};
